/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:02:45
 */

import axios from 'axios';
// import NProgress from 'NProgress'
// import 'nprogress/nprogress.css'

// NProgress.inc(0.4)
// NProgress.configure({ easing: 'ease', speed: 600, showSpinner: false})

const BASE_API_URL = import.meta.env.VITE_BASE_URL
console.log(import.meta.env,'axios')

class Data {
    static getInstance() {
        if (!this.instance) this.instance = new Data()
        return this.instance
    }

    getData(url, params, method, dataType) {
        url = import.meta.env.MODE == 'development' ? url : `${BASE_API_URL}${url}`

        if (import.meta.env.MODE == 'production') {
            if (url.indexOf('/api') > -1){url = url.replace('/api', '')} 
        }

        if (method == 'GET' || method == 'get') {
            let urlParam = ''
            for (let key in params) {
                urlParam = urlParam == '' ? `?${key}=${encodeURIComponent(params[key])}` : `${urlParam}&${key}=${encodeURIComponent(params[key])}`
            }
            url = url + urlParam
        }
        // console.log(url,'url')

        let token = localStorage.getItem('hd_ota_token')
        let config = {
            headers: {
                'Content-Type': dataType? dataType : 'application/json;charset=utf-8',
                'Authorization': token == null? '' : 'Bearer ' + token,
            },
            method: method,
            timeout: 6 * 60 * 1000,
            url: url,
            data: params,
            responseType:'blob'
        }

        // NProgress.start();
        return new Promise((resolve, reject) => {
            axios(config).then(res => {
                console.log(res,'res222222222222')
                if (res.data.code == 401) {

                } else {
                    // resolve(res.data)

                    if(res.data.type === 'application/json'){
                        let reader = new FileReader()
                        reader.readAsText(res.data,'utf-8')
                        reader.onload = ()=>{
                            let msg = JSON.parse(reader.result)
                            resolve(msg)
                        }
                    }else if(res.data.type === 'application/octet-stream'){
                        resolve(res.data)
                    }
                }
            }).catch(error => {
                console.log(error, 'error')
                if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
                    resolve(error)
                }

                // resolve(error.response.data)

                else if (error.response && error.response.data.type === 'application/json') {
                    let reader = new FileReader()
                    reader.readAsText(error.response.data, 'utf-8')
                    reader.onload = () => {
                        let msg = JSON.parse(reader.result)
                        resolve(msg)
                    }
                }
            })
        })
    }
}

export {
    Data
}